import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import RadioGroup from "../components/Form/RadioGroup";

export const APPEAL_FOR_MYSELF = "appelformyself";
export const PARENT = "parent";
export const FIDUCIARY = "fiduciary";
export const HAVE_FIDUCIARY = "havefiduciary";

export default function AppealForWho() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {

                    const prev = formData.appealforwho;
                    const next = values.appealforwho;

                    const otherRoles = [FIDUCIARY, HAVE_FIDUCIARY, PARENT];

                    const switchedBetweenSelfAndOther =
                        (prev === APPEAL_FOR_MYSELF && otherRoles.includes(next)) ||
                        (otherRoles.includes(prev) && next === APPEAL_FOR_MYSELF);

                    setFormData({
                        ...formData,
                        ...values,
                        ...(switchedBetweenSelfAndOther && {
                            firstname: "",
                            lastname: "",
                            email: "",
                            phone: "",
                            reporterEmail: "",

                        }),
                    });

                    navigate("/kontaktuppgifter");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    appealforwho: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänlig ange vem du överklagar som",
                        (value) => {
                            return value === APPEAL_FOR_MYSELF ||
                                value === FIDUCIARY ||
                                value === HAVE_FIDUCIARY ||
                                value === PARENT

                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"77"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="appealForWhoHeading">
                                    Vem överklagar du för?
                                </h2>

                                <p>
                                    Om resenären är under 18 år behöver du ange en mejladress till en vårdnadshavare, god man eller ett ombud.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <RadioGroup name="appealforwho" options={[
                                    { id: "appelformyself", value: "appelformyself", label: "Jag överklagar för mig själv" },
                                    { id: "parent", value: "parent", label: "Jag är vårdnadshavare/förälder åt resenären" },
                                    { id: "fiduciary", value: "fiduciary", label: "Jag är god man/ombud åt resenären" },
                                    { id: "havefiduciary", value: "havefiduciary", label: "Jag har en god man/ett ombud" }
                                ]} />

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
